import React, { useEffect, useRef, useState } from "react";
import "../assets/css/Facilities.css";
import raipurCampus1 from "../assets/img/campus/raipur-campus-1.jpeg";
import raipurCampus2 from "../assets/img/campus/raipur-campus-2.jpeg";
import raipurCampus3 from "../assets/img/campus/raipur-campus-3.jpeg";

import campus1 from "../assets/img/campus/campus-1.webp";
import campus2 from "../assets/img/campus/campus-2.webp";
import campus3 from "../assets/img/campus/campus-3.webp";

import facility1 from "../assets/img/campus/library.png";
import facility2 from "../assets/img/campus/laboratories.png";
import facility3 from "../assets/img/campus/classrooms.png";
import facility4 from "../assets/img/campus/sports.png";
import facility5 from "../assets/img/campus/hostels.png";
import facility6 from "../assets/img/campus/halls.png";
import facility7 from "../assets/img/campus/courtroom.png";
import facility8 from "../assets/img/campus/student-support.png";

import learn from "../assets/img/campus/classrooms-4.png";
import discover from "../assets/img/campus/laboratories-2.png";
import move from "../assets/img/campus/sports-2.png";
import live from "../assets/img/campus/hostels-2.png";

const campusData = {
  raipur: {
    number: "01",
    label: "Raipur Campus",
    title: "A contemporary academic environment in the heart of opportunity.",
    description:
      "Technology-enabled learning spaces and student-focused facilities connect classroom knowledge with practical experience.",
    mainImage: raipurCampus1,
    sideImageOne: raipurCampus2,
    sideImageTwo: raipurCampus3,
  },
  gariyaband: {
    number: "02",
    label: "Gariyaband Campus",
    title: "An immersive campus experience surrounded by space and nature.",
    description:
      "A residential learning environment bringing academics, research, recreation and community life together in one connected campus.",
    mainImage: campus1,
    sideImageOne: campus2,
    sideImageTwo: campus3,
  },
};

const facilities = [
  {
    name: "Central Library",
    kicker: "Academic resource",
    icon: "⌑",
    image: facility1,
    description:
      "A focused knowledge environment with books, journals, digital resources and dedicated areas for reading, individual study and collaborative learning.",
    points: [
      "Books, journals and publications",
      "E-books and digital learning resources",
      "Quiet and collaborative study zones",
    ],
  },
  {
    name: "Advanced Laboratories",
    kicker: "Practical learning",
    icon: "⚗",
    image: facility2,
    description:
      "Discipline-specific laboratories enable experimentation, hands-on practice and research-led exploration across academic programmes.",
    points: [
      "Science and research laboratories",
      "Engineering and pharmaceutical labs",
      "Language and management learning spaces",
    ],
  },
  {
    name: "Smart Classrooms",
    kicker: "Connected learning",
    icon: "▣",
    image: facility3,
    description:
      "Well-designed classrooms support presentations, collaboration and a balance of traditional and technology-enabled teaching.",
    points: [
      "Technology-supported teaching",
      "Comfortable learning environment",
      "Spaces for discussion and teamwork",
    ],
  },
  {
    name: "Sports & Fitness",
    kicker: "Active campus",
    icon: "◉",
    image: facility4,
    description:
      "Playgrounds, courts, indoor games and fitness facilities encourage participation, wellbeing and competitive spirit.",
    points: [
      "Cricket, football and basketball",
      "Badminton and indoor games",
      "Gymnasium and fitness equipment",
    ],
  },
  {
    name: "Student Hostels",
    kicker: "Residential life",
    icon: "⌂",
    image: facility5,
    description:
      "Comfortable accommodation and shared study areas create a secure, convenient and community-oriented residential experience.",
    points: [
      "Separate accommodation facilities",
      "Furnished living and study spaces",
      "Support for a comfortable campus life",
    ],
  },
  {
    name: "Auditorium & Seminar Halls",
    kicker: "Ideas and expression",
    icon: "◫",
    image: facility6,
    description:
      "Event-ready spaces host workshops, expert sessions, conferences, cultural programmes and annual celebrations.",
    points: [
      "Academic and industry events",
      "Workshops and guest sessions",
      "Cultural and student programmes",
    ],
  },
  {
    name: "Moot Court",
    kicker: "Legal education",
    icon: "⚖",
    image: facility7,
    description:
      "A simulated courtroom environment helps law students practise advocacy, legal reasoning and professional courtroom procedures.",
    points: [
      "Advocacy and trial simulations",
      "Legal research and presentation",
      "Professional courtroom experience",
    ],
  },
  {
    name: "Student Support",
    kicker: "Campus convenience",
    icon: "✦",
    image: facility8,
    description:
      "Transport, cafeteria, medical support, clubs and placement services make everyday campus life more connected and convenient.",
    points: [
      "Campus transportation",
      "Cafeteria and medical support",
      "Training, placement and student clubs",
    ],
  },
];

const padNumber = (value) => String(value).padStart(2, "0");

export default function Facilities() {
  const sectionRef = useRef(null);
  const facilityRailRef = useRef(null);
  const railRefs = useRef([]);
  const [campusKey, setCampusKey] = useState("raipur");
  const [activeFacility, setActiveFacility] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  const campus = campusData[campusKey];
  const facility = facilities[activeFacility];

  const changeCampus = (key) => {
    if (key === campusKey) return;
    setIsChanging(true);
    window.setTimeout(() => {
      setCampusKey(key);
      setIsChanging(false);
    }, 180);
  };

  const showFacility = (index) => {
    const nextIndex = (index + facilities.length) % facilities.length;
    setIsChanging(true);
    window.setTimeout(() => {
      setActiveFacility(nextIndex);
      setIsChanging(false);

      const rail = facilityRailRef.current;
      const activeCard = railRefs.current[nextIndex];

      if (rail && activeCard) {
        const centeredPosition =
          activeCard.offsetLeft -
          (rail.clientWidth - activeCard.offsetWidth) / 2;

        rail.scrollTo({
          left: Math.max(0, centeredPosition),
          behavior: "smooth",
        });
      }
    }, 170);
  };

  useEffect(() => {
    const root = sectionRef.current;
    if (
      !root ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return undefined;
    }

    const elements = root.querySelectorAll("[data-reveal]");
    elements.forEach((element) => element.classList.add("facility-reveal"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("facility-reveal--visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="campus-facilities"
      id="campus-facilities"
      ref={sectionRef}
    >
      <div className="facility-orb facility-orb--one" aria-hidden="true" />
      <div className="facility-orb facility-orb--two" aria-hidden="true" />

      <div className="facility-container">
        <header className="facility-heading" data-reveal>
          <div className="facility-heading__title">
            <span className="facility-eyebrow">
              <i /> Campus facilities
            </span>
            <h2>
              Spaces designed for <em>every dimension of growth.</em>
            </h2>
          </div>
          <div className="facility-heading__copy">
            <p>
              From focused learning and practical discovery to recreation,
              wellbeing and community life, our campuses create an environment
              where students can learn confidently and live fully.
            </p>
            <a href="#facility-explorer" className="facility-text-link">
              Explore the experience <span>↓</span>
            </a>
          </div>
        </header>

        <div
          className="campus-switcher"
          role="tablist"
          aria-label="Select campus"
          data-reveal
        >
          {Object.entries(campusData).map(([key, item]) => (
            <button
              key={key}
              className={`campus-switcher__button ${campusKey === key ? "active" : ""
                }`}
              type="button"
              role="tab"
              aria-selected={campusKey === key}
              onClick={() => changeCampus(key)}
            >
              <span className="campus-switcher__number">{item.number}</span>
              <span>
                <small>
                  {key === "raipur"
                    ? "City-connected learning"
                    : "Immersive residential experience"}
                </small>
                <strong>{item.label}</strong>
              </span>
              <i>↗</i>
            </button>
          ))}
        </div>

        <div
          className={`campus-visual ${isChanging ? "facility-fade" : ""}`}
          aria-live="polite"
          data-reveal
        >
          <div className="campus-visual__main">
            <img src={campus.mainImage} alt={`${campus.label} building`} />
            <div className="campus-visual__shade" />
            <div className="campus-visual__content">
              <span>{campus.label}</span>
              <h3>{campus.title}</h3>
              <p>{campus.description}</p>
            </div>
            <div className="campus-visual__counter">
              <strong>{campus.number}</strong>
              <i />
              <span>02 campuses</span>
            </div>
          </div>
          <div className="campus-visual__side campus-visual__side--top">
            <img src={campus.sideImageOne} alt="University library" />
            <span>Knowledge spaces</span>
          </div>
          <div className="campus-visual__side campus-visual__side--bottom">
            <img src={campus.sideImageTwo} alt="University laboratory" />
            <span>Practical discovery</span>
          </div>
          <div className="campus-visual__badge">
            <strong>26</strong>
            <span>
              Acres of
              <br />
              learning environment
            </span>
          </div>
        </div>

        <div
          className="facility-explorer"
          id="facility-explorer"
          data-reveal
        >
          <div className="facility-explorer__intro">
            <span className="facility-eyebrow">
              <i /> Explore facilities
            </span>
            <h3>
              Everything students need, <em>thoughtfully connected.</em>
            </h3>
            <p>
              Select a facility to discover how each space contributes to
              academic achievement, personal wellbeing and campus life.
            </p>
            <div className="facility-explorer__controls">
              <button
                type="button"
                onClick={() => showFacility(activeFacility - 1)}
                aria-label="Previous facility"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => showFacility(activeFacility + 1)}
                aria-label="Next facility"
              >
                →
              </button>
              <span>
                <strong>{padNumber(activeFacility + 1)}</strong> /{" "}
                <small>{padNumber(facilities.length)}</small>
              </span>
            </div>
          </div>

          <div
            className={`facility-explorer__display ${isChanging ? "facility-fade" : ""
              }`}
          >
            <div className="facility-display__image">
              <img src={facility.image} alt={facility.name} />
              <span aria-hidden="true"><i className={`ti ti-${facility.icon}`}></i></span>
            </div>
            <article className="facility-display__content">
              <span>{facility.kicker}</span>
              <h4>{facility.name}</h4>
              <p>{facility.description}</p>
              <ul>
                {facility.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </article>
          </div>

          <div
            className="facility-rail"
            ref={facilityRailRef}
            role="tablist"
            aria-label="Campus facilities"
          >
            {facilities.map((item, index) => (
              <button
                key={item.name}
                ref={(element) => {
                  railRefs.current[index] = element;
                }}
                type="button"
                role="tab"
                aria-selected={activeFacility === index}
                className={activeFacility === index ? "active" : ""}
                onClick={() => showFacility(index)}
              >
                <span>{padNumber(index + 1)}</span>
                <strong>{item.name}</strong>
              </button>
            ))}
          </div>
        </div>

        <div className="facility-stories">
          <article className="facility-story facility-story--large" data-reveal>
            <div className="facility-story__image">
              <img
                src={learn}
                alt="Technology-enabled university classroom"
                loading="lazy"
              />
            </div>
            <div className="facility-story__content">
              <span>01 · Learn</span>
              <h3>Classrooms made for active learning.</h3>
              <p>
                Technology-enabled classrooms, seminar rooms and lecture halls
                support presentations, discussion and collaborative work.
              </p>
              <a href="/raipur-campus">
                Discover academic spaces <i>↗</i>
              </a>
            </div>
          </article>

          <article className="facility-story facility-story--reverse" data-reveal>
            <div className="facility-story__content">
              <span>02 · Discover</span>
              <h3>Laboratories where theory becomes experience.</h3>
              <p>
                Computer, science, engineering, research, language and
                pharmaceutical laboratories develop practical capabilities.
              </p>
              <div className="facility-story__tags">
                {["Science", "Engineering", "Computing", "Pharmacy"].map(
                  (tag) => (
                    <small key={tag}>{tag}</small>
                  )
                )}
              </div>
            </div>
            <div className="facility-story__image">
              <img
                src={discover}
                alt="Students learning in a science laboratory"
                loading="lazy"
              />
            </div>
          </article>

          <div className="facility-life-grid">
            <article
              className="facility-life-card facility-life-card--wide"
              data-reveal
            >
              <img
                src={move}
                alt="Outdoor university sports facilities"
                loading="lazy"
              />
              <div>
                <span>Move</span>
                <h4>Sports &amp; recreation</h4>
                <p>
                  Playgrounds, courts, indoor games and a gymnasium support an
                  active campus lifestyle.
                </p>
              </div>
            </article>
            <article className="facility-life-card" data-reveal>
              <img
                src={live}
                alt="Comfortable student accommodation"
                loading="lazy"
              />
              <div>
                <span>Live</span>
                <h4>Student hostels</h4>
                <p>
                  Safe and comfortable residential facilities for focused,
                  connected campus living.
                </p>
              </div>
            </article>
            <article
              className="facility-life-card facility-life-card--dark"
              data-reveal
            >
              <div className="facility-life-card__icon" aria-hidden="true">
                ✦
              </div>
              <div>
                <span>Connect</span>
                <h4>Clubs &amp; student life</h4>
                <p>
                  Cultural, scientific and student-led activities encourage
                  participation beyond academics.
                </p>
              </div>
            </article>
          </div>
        </div>

        <footer className="facility-cta" data-reveal>
          <div>
            <span className="facility-eyebrow">
              <i /> Visit the campus
            </span>
            <h3>See where your university journey could begin.</h3>
          </div>
          <div className="facility-cta__actions">
            <a href="/raipur-campus">
              Explore Raipur <span>↗</span>
            </a>
            <a href="/gariyaband-campus">
              Explore Gariyaband <span>↗</span>
            </a>
          </div>
        </footer>
      </div>
    </section>
  );
}